import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from "react-transition-group";
import ScrollToTop from 'react-router-scroll-top';

import Projects from '../routes/Projects';
import About from '../routes/About';
import Sheltertech from '../routes/Projects/Sheltertech';
import Askdarcel from '../routes/Projects/Askdarcel';
import BeboTournaments from '../routes/Projects/BeboTournaments';
import BeboStreaming from '../routes/Projects/BeboStreaming';
import GnostMono from '../routes/Projects/GnostMono';
import Twitch from '../routes/Projects/Twitch';
import EsportsOne from '../routes/Projects/EsportsOne';
import ClimateDashboard from '../routes/Projects/ClimateDashboard';
import UrbanMobility from '../routes/Projects/UrbanMobility';
import YNABMobile from '../routes/Projects/YNABMobile';
import YNABTwitch from '../routes/Projects/YNABTwitch';

function Container({ location }) {
  return (
    <div className="container">
      <ScrollToTop>
        <TransitionGroup>
          <CSSTransition
            key={location.key}
            timeout={{ enter: 300, exit: 300 }}
            classNames={'fade'}
          >
            <Switch location={location}>
              <Route path="/" exact component={Projects} />
              <Route path="/about/" component={About} />
              <Route path="/sheltertech/" component={Sheltertech} />
              <Route path="/askdarcel/" component={Askdarcel} />
              <Route path="/bebotournaments/" component={BeboTournaments} />
              <Route path="/bebostreaming/" component={BeboStreaming} />
              <Route path="/gnostmono/" component={GnostMono} />
              <Route path="/twitch/" component={Twitch} />
              <Route path="/esportsone/" component={EsportsOne} />
              <Route path="/climatedashboard/" component={ClimateDashboard} />
              <Route path="/urbanmobility/" component={UrbanMobility} />
              <Route path="/ynabmobile/" component={YNABMobile} />
              <Route path="/ynabtwitch/" component={YNABTwitch} />
            </Switch>
          </CSSTransition>
        </TransitionGroup>
      </ScrollToTop>
    </div>
  )
}

export default withRouter(Container);
